import React, { useState, useEffect } from 'react';
import { Badge, InputGroup, Form, Button } from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import { oneKlicks } from '../../../SDK/oneclick';
import ImageShow from '../../../Uitiles/ImageShow';
import { toast } from 'react-toastify';
import AddAiService from './Components/AddAiService';
import EditAiService from './Components/EditAiService';
import ViewAiService from './Components/ViewAiService';


const AiServices = () => {
    const [search, setSearch] = useState('');
    const [aiServices, setAiServices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);
    const [openView, setOpenView] = useState(false);
    const [selectedService, setSelectedService] = useState(null);

    useEffect(() => {
        getAiServices();
    }, []);

    const getAiServices = async () => {
        setLoading(true);
        try {
            const tableSchema = '';
            const tableName = 'front_end_sessions';
            const conditions = {
                kaey:'ai_services',
                status: 'active'
            };
            const orderBy = 'id DESC';
            const search = {};
            const pagination = {};
            const margedata = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("front_end_sessions response :", response);
            if (response.data && response.data.length > 0) {
                try {
                    const parsedData = JSON.parse(response.data[0].data);
                    console.log("front_end_sessions parsedData :", parsedData);
                    setAiServices(parsedData);
                    console.log("front_end_sessions setAiServices :", aiServices);
                } catch (error) {
                    console.error("front_end_sessionsError parsing AI service data:", error);
                    setAiServices([]);
                }
            } else {
                setAiServices([]);
            }
        } catch (error) {
            console.error('getAiServices response error :', error);
            setAiServices([]);
        } finally {
            setLoading(false);
        }
    }

    const handleDelete = async (service) => {
        console.log("service", service);
        const confirmDelete = window.confirm(`Are you sure you want to delete "${service.name}"?`);
        if (confirmDelete) {
            try {
                // Remove the service from the array
                const updatedServices = aiServices.filter(s => s.id !== service.id);
                
                const data = {
                    kaey: "ai_services",
                    status: 'active',
                    data: JSON.stringify(updatedServices)
                };
                
                const tableSchema = '';
                const tableName = 'front_end_sessions';
                const conditions = {
                    kaey: 'ai_services'
                };
                
                const response = await oneKlicks.update(tableSchema, tableName, data, conditions);
                
                if (response.success) {
                    toast.success('AI Service deleted successfully');
                    getAiServices(); // Refresh the list
                } else {
                    toast.error('Failed to delete AI Service');
                }
            } catch (error) {
                console.error('handleDelete error :', error);
                toast.error('An error occurred while deleting the service');
            }
        }
    }

    const handleEdit = (service) => {
        setSelectedService(service);
        setOpenEdit(true);
    };

    const handleView = (service) => {
        setSelectedService(service);
        setOpenView(true);
    };

    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2  mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">AI Services</h5>
                                <Badge bg="info">Front End Management</Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <InputGroup className="p-0" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                                    <Form.Control
                                        placeholder="Search..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </InputGroup>
                                <Button variant="primary" onClick={() => setShowAdd(true)}>+ Add AI Service</Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <Table hover size="sm" className="mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Name</th>
                                        <th>Image</th>
                                        <th>Description</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {aiServices.length > 0 ? (
                                        aiServices.map((service, index) => (
                                            <tr key={index}>
                                                <td data-label="ID">{index + 1}</td>
                                                <td data-label="Name">{service.name}</td>
                                                <td data-label="Image"><ImageShow url={service.image} width={40} height={40} style={{ objectFit: 'cover', borderRadius: '50%' }} /></td>
                                                <td data-label="Description">{service.description}</td>
                                                <td data-label="Action">
                                                    <div className="d-flex gap-2 justify-content-center" style={{ gap: 10 }}> 
                                                        <Button variant="info" size="sm" onClick={() => handleView(service)}>View</Button>
                                                        <Button variant="primary" size="sm" onClick={() => handleEdit(service)}>Edit</Button>
                                                        <Button variant="danger" size="sm" onClick={() => handleDelete(service)}>Delete</Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={5} className="text-center">No data found</td>
                                        </tr>
                                    )}
                                    
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
            <AddAiService showAdd={showAdd} setShowAdd={setShowAdd} getAiServices={getAiServices} oldData={aiServices}/>
            <EditAiService openEdit={openEdit} setOpenEdit={setOpenEdit} getAiServices={getAiServices} selectedService={selectedService} />
            <ViewAiService openView={openView} setOpenView={setOpenView} selectedService={selectedService} />
        </div>
    );
};

export default AiServices;
